import { connect } from 'react-redux';
import ThemeProvider from './ThemeProvider';
function mapStateToProps(state) {
  return {
    theme: state.ui.theme.currentTheme || state.ui.theme.defaultTheme
  };
}
export default connect(mapStateToProps)(ThemeProvider);